module.exports = __webpack_public_path__ + "img/pay_pal.b59f84e9.svg";